import React from 'react';
import {
  Store as StoreIcon,
  School as SchoolIcon,
  Dashboard as DashboardIcon,
  Group as People,
  Note as NoteIcon,
  Forum as ForumIcon
} from '@mui/icons-material';

/**
 * 创建教师侧边栏配置（分组导航，与学生侧边栏结构一致）
 * @param {Object} options
 * @param {Function} options.navigate - 路由跳转
 * @param {Object} options.user - 当前用户
 * @param {Object} options.selectedCourse - 当前选中课程
 * @param {Function} options.onLogout - 退出登录
 * @param {string} options.currentPath - 当前路径，用于高亮
 * @param {number} options.tabValue - 可选，Dashboard 的 tab（0=总览，1=学生管理）
 * @param {Function} options.setTabValue - 可选，Dashboard 切换 tab
 */
export function createTeacherSidebarConfig({
  navigate,
  user,
  selectedCourse,
  onLogout,
  currentPath = '/dashboard',
  tabValue,
  setTabValue
}) {
  const isActive = (path) => currentPath === path || currentPath.startsWith(path + '/');
  const isOnDashboard = isActive('/dashboard');
  const isOverviewSelected = isOnDashboard && (tabValue === undefined || tabValue === 0);
  const isStudentsSelected = isOnDashboard && tabValue === 1;

  const goToOverview = () => {
    navigate('/dashboard');
    if (setTabValue) setTabValue(0);
  };
  const goToStudents = () => {
    navigate('/dashboard');
    if (setTabValue) setTabValue(1);
  };

  return {
    courseName: selectedCourse?.name,
    courseTermCode: selectedCourse?.termCode,
    userInfo: { name: user?.name, role: '教师账号', avatar: user?.avatar },
    onLogout,
    navigationGroups: [
      {
        subHeading: '导航',
        items: [
          {
            icon: <StoreIcon color={isActive('/marketplace') ? 'primary' : 'inherit'} />,
            label: '商城',
            selected: isActive('/marketplace'),
            onClick: () => navigate('/marketplace')
          },
          {
            icon: <SchoolIcon color={isActive('/courses') ? 'primary' : 'inherit'} />,
            label: '课程',
            selected: isActive('/courses'),
            onClick: () => navigate('/courses')
          }
        ]
      },
      {
        subHeading: '课程管理',
        items: [
          {
            icon: <DashboardIcon color={isOverviewSelected ? 'primary' : 'inherit'} />,
            label: '总览',
            selected: isOverviewSelected,
            onClick: goToOverview
          },
          {
            icon: <People color={isStudentsSelected ? 'primary' : 'inherit'} />,
            label: '学生管理',
            selected: isStudentsSelected,
            onClick: goToStudents
          },
          {
            icon: <NoteIcon color={isActive('/notebooks') || isActive('/notebook') ? 'primary' : 'inherit'} />,
            label: '课程笔记',
            selected: isActive('/notebooks') || isActive('/notebook'),
            onClick: () => navigate('/notebooks')
          },
          {
            icon: <ForumIcon color={isActive('/forum') ? 'primary' : 'inherit'} />,
            label: '课程论坛',
            selected: isActive('/forum'),
            onClick: () => navigate('/forum')
          }
        ]
      }
    ],
    navigationItems: []
  };
}
